import React from 'react';

const AreasOfFocus = () => {
  const areas = [
    {
      title: 'Brand Commercials That Convert',
      description: 'I do not just make ads - I create brand experiences that drive results. Over the past decade, I have worked with major brands like Goodknight (ft. Kareena Kapoor Khan), Mother Dairy (ft. Tisca Chopra), TATA Neu, Surf Excel, and Jaquar to craft commercials that do not just look beautiful, but actually move the needle. Whether it is a celebrity campaign, a social impact film, or a luxury product showcase, every frame is designed to captivate audiences and deliver measurable impact for your brand.',
      link: 'https://vimeo.com/irammy',
      showButton: true,
      buttonText: 'Explore 100+ Commercials'
    },
    {
      title: 'Award-Winning Storytelling',
      description: 'Film is where my heart lives. My short films - Una, Rinti (Dadasaheb Phalke Award winner), and The Unknown Codes - have traveled to festivals worldwide and proven that powerful storytelling transcends formats. Currently, I am channeling this passion into my first feature film, an ambitious project that will push creative boundaries and bring cinematic depth to new audiences. Whether you need a compelling narrative film, web series, or branded content that tells a real story, I bring the same level of craft and emotional depth to every project.',
      link: '#movies',
      showButton: false
    }
  ];

  return (
    <section className="bg-gray-50 py-20">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-light text-gray-800 mb-4">What I Do Best</h2>
          <p className="text-lg text-gray-600 font-light max-w-3xl mx-auto">
            Two core specializations, one driving philosophy: create work that matters
          </p>
        </div>

        <div className="space-y-16">
          {areas.map((area, index) => (
            <div key={index} className="border-b border-gray-200 pb-16 last:border-b-0">
              <h3 className="text-2xl md:text-3xl font-light text-gray-900 mb-6">{area.title}</h3>
              <p className="text-gray-700 text-lg leading-relaxed mb-8 font-light">
                {area.description}
              </p>
              {area.showButton && (
                <a
                  href={area.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center space-x-2 text-gray-600 hover:text-white hover:bg-gray-900 font-light text-sm border border-gray-900 px-8 py-3 transition-all duration-300"
                >
                  <span>{area.buttonText}</span>
                  <span>→</span>
                </a>
              )}
            </div>
          ))}
        </div>

        <div className="mt-16 p-8 bg-white border border-gray-200 text-center">
          <h3 className="text-2xl font-light text-gray-900 mb-4">
            Ready to create something exceptional?
          </h3>
          <p className="text-gray-600 font-light mb-6">
            Let's discuss how we can bring your vision to life through cinematic storytelling
          </p>
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-block bg-gray-900 hover:bg-gray-800 text-white px-10 py-4 transition-all duration-300 font-light cursor-pointer"
          >
            Start a Conversation
          </a>
        </div>
      </div>
    </section>
  );
};

export default AreasOfFocus;
